<template>
  <Navbar/>
  <Slider/>
</template>

<script>
import Navbar from '@/components/categories/Navbar';
import Slider from '@/components/categories/Slider';

export default {
  components: {Navbar, Slider},
}
</script>
